// src/utils/scrollHelpers.js

/**
 * Smoothly scrolls to a section by ID
 * @param {string} id - The ID of the section to scroll to
 */
export const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};